<script>
  import { format } from 'svelte-i18n';
  import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Input, Row, Tooltip } from '@sveltestrap/sveltestrap';

  export let rulename = '';
  export let objectType = '';
  export let deleteRequirementType = '';
  export let deleteRequirementParam = '';
  export let onDelete = () => {};

  let deleteConfirmation = '';
  let showDeleteConfirmation = false;

  const confirmDeletion = async () => {
    await onDelete();
  };

  const toggleConfirmation = () => (showDeleteConfirmation = !showDeleteConfirmation);
</script>

<div class="section">
  <div class="delete-group">
    <h2>{$format('label.DELETE')}</h2>
    <p>
      {@html $format('label.DELETE_WARNING', {
        values: { type: $format(objectType).toLowerCase() }
      })}
    </p>
    {#if showDeleteConfirmation}
      <div class="delete-confirmation">
        <input
          type="text"
          bind:value={deleteConfirmation}
          placeholder={$format('label.PLACEHOLDER.DELETE', {
            values: {
              type: $format(deleteRequirementType).toLowerCase(),
              param: $format(deleteRequirementParam).toLowerCase()
            }
          })}
        />
        <Button color="danger" disabled={deleteConfirmation !== rulename} on:click={confirmDeletion}>
          {$format('label.DELETE')}
        </Button>
        <Button color="secondary" on:click={toggleConfirmation}>{$format('label.CANCEL')}</Button>
      </div>
      <small>
        {$format('label.DELETE_REQUIREMENT', {
          values: {
            type: $format(deleteRequirementType).toLowerCase(),
            param: $format(deleteRequirementParam).toLowerCase()
          }
        })}
      </small>
    {:else}
      <Button color="danger" on:click={toggleConfirmation}>{$format('label.DELETE')}</Button>
    {/if}
  </div>
</div>

<style lang="scss" src="./delete-warning.scss"></style>
